import StudioPage from './StudioPage'

export { StudioPage }

export default StudioPage
